import api from '../../services/api'
import {
  GROUP_SUCCESS,
  GROUP_CREATE,
  GROUP_DELETE,
  GROUP_EDIT
} from '../types'

function getGroups () {
  return (dispatch) => {
    return api.group.getGroups().then((response) => {
      if (response && !response.data.error) {
        dispatch({
          type: GROUP_SUCCESS,
          payload: response.data.result
        })
      }
    })
  }
}

function createGroup (data) {
  return (dispatch) => {
    return api.group.createGroup(data).then((response) => {
      if (response && !response.data.error) {
        dispatch({
          type: GROUP_CREATE,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function deleteGroup (id) {
  return (dispatch) => {
    return api.group.deleteGroup(id).then((response) => {
      if (response && !response.data.error) {
        dispatch({
          type: GROUP_DELETE,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function editGroup (id, name) {
  return (dispatch) => {
    return api.group.editGroup(id, name).then((response) => {
      if (response && !response.data.error) {
        dispatch({
          type: GROUP_EDIT,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

export {
  getGroups,
  createGroup,
  deleteGroup,
  editGroup
}



// WEBPACK FOOTER //
// ./src/store/actions/group.js